import { useContext } from 'react';

import { QuestionReviewTaskDetailsContext } from './question-review-task-details-provider';

export function useQuestionReviewTaskDetails() {
  const context = useContext(QuestionReviewTaskDetailsContext);

  if (context === undefined) {
    throw new Error(
      'useQuestionReviewTaskDetails must be used within a QuestionReviewTaskDetailsProvider',
    );
  }

  return context;
}
